import { RANGE_FILTERS } from '../Filterbar/constants';

export const buildSelectItems = rangeFiltersMinMax => {
	const items = [];

	for (const [key] of Object.entries(rangeFiltersMinMax)) {
		const attribute = RANGE_FILTERS.find(rf => rf.name === key);

		items.push({
			label: attribute ? attribute.label : key,
			value: key
		});
	}

	return items;
};

export const checkRangeFiltersData = rangeFiltersMinMax =>
	Object.keys(rangeFiltersMinMax).length === 0 && rangeFiltersMinMax.constructor === Object;

export const generateChartData = (filterName, rangeFiltersMinMax) => {
	const data = [];

	if (rangeFiltersMinMax[filterName] && rangeFiltersMinMax[filterName].designCount) {
		const rangeFilterMinMax = rangeFiltersMinMax[filterName];
		for (let i = 0; i < rangeFilterMinMax.designCount.length; ++i) {
			data.push({
				interval: rangeFilterMinMax.marks[i].value + ' - ' + rangeFilterMinMax.marks[i + 1].value,
				designCount: rangeFilterMinMax.designCount[i]
			});
		}
	}

	return data;
};
